export const DIRECTED_AT = {
  "My Supervisor": {
    id: 1,
    label: "My Supervisor",
    value: "SUPERVISOR",
  },
  "My Direct Reports": {
    id: 2,
    label: "My Direct Reports",
    value: "DIRECT_REPORT",
  },
  "My Teammates": {
    id: 3,
    label: "My Teammates",
    value: "PEER",
  },
};
